import { createSelector } from 'reselect';
import { RootState } from '../../store';

export const selectStateChangeUnitSensor = createSelector(
    (state: RootState, id: number | string | undefined) => {
        return state.stateChange.unit?.data.find(item => item.id === id);
    },
    state => state,
);
